namespace SP {
    export interface ProductionItemQuickInfo {
        item: ItemInfo;
        quantity: number;
    }
    export interface ProductionQuickInfo {
        totalOrders: number;
        orderCount: number;
        orders: string[];
        productionItems: ProductionItemQuickInfo[]
    }
}